import React from 'react';
import { FullTable } from '@/components/ui/FullTable';
import { Contact } from './types';

interface ContactsTableProps {
  data: Contact[];
  columns: any[];
  isLoading: boolean;
  onRowClick: (contact: Contact) => void;
}

/**
 * ContactsTable component displays the contacts in a table format
 */
const ContactsTable: React.FC<ContactsTableProps> = ({
  data,
  columns,
  isLoading,
  onRowClick
}) => {
  return (
    <div className="mt-2" data-test-id="contacts-table-container">
      <FullTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        onRowClick={onRowClick}
        data-test-id="contacts-table"
      />
    </div>
  );
};

export default ContactsTable;
